<template>
    <div class="l-code-mirror">
        <textarea ref="codeEditor"></textarea>        
    </div>
</template>
<script>
export default {
    name:'l-code-editor',
    props: {
        value:{},
        mode:{
            type:String,
            default:'application/javascript'
        },
        readonly:{
            type:Boolean,
            default:false
        },
        disabled:{
            type:Boolean,
            default:false
        },
        theme:{
            type: String,
            default:'default'
        },
        isHint:Boolean,
        handleHint:Function
    },
    watch:{
        value:{
            handler(val){
                if(val != this.value2){
                    this.value2 = val
                    this.editor && this.editor.setValue(val)
                    setTimeout(()=>{
                        this.editor && this.editor.refresh()
                    })
                }
            },
            immediate:true
        },
        mode:{
            handler(val){
                this.editor && this.editor.setOption("mode",val)
            },
            immediate:true
        }
    },
    data(){
        return{
            editor:null,
            value2:'',
            chatVisible: false
        }
    },
    computed:{
        
    },
    mounted(){
        if (!window.CodeMirror) {
            console.error('CodeMirror is not loaded!');
            return;
        }
        this.init();
    },
    beforeDestroy(){
        this.editor.off("change")
        this.editor = null
    },
    methods:{
        init(){
            const theme = this.theme && this.theme !== 'default' ? this.theme : 'default';
            console.log(theme)
            const options = {
                // 基础配置
                lineNumbers: true,
                mode: this.mode,
                theme: theme,
                readOnly: this.readonly,  // 确保非只读时可操作

                // 缩进与代码结构
                indentUnit: 4,            // 缩进空格数
                indentWithTabs: false,     // 用空格替代制表符（true 则用 \t）
                smartIndent: true,        // 智能缩进
                matchBrackets: true,      // 括号匹配高亮
                autoCloseBrackets: true,  // 自动闭合括号

                // 交互增强
                lineWrapping: true,       // 自动换行
                styleActiveLine: true,    // 当前行高亮
                highlightSelectionMatches: { 
                    showToken: true,        // 高亮选中文本的所有匹配项
                    annotateScrollbar: true 
                },

                // 功能扩展
                foldGutter: true,        // 代码折叠
                gutters: [
                    "CodeMirror-linenumbers", 
                    "CodeMirror-foldgutter", 
                    "CodeMirror-matchingbracket"  // 括号匹配提示
                ],
                // ============== 折叠逻辑增强 ==============
                autoCollapse: false, // 是否自动折叠嵌套块（默认关闭）
                foldOptions: {
                    widget: "↕", // 自定义折叠按钮符号
                    scanUp: true, // 允许向上扫描折叠块
                    minFoldSize: 4 // 最小折叠行数（小于该值不显示折叠按钮）
                },

                // 快捷键配置（关键修正）
                extraKeys: { 
                    "Tab": (cm) => cm.execCommand("indentMore"),
                    "Shift-Tab": (cm) => cm.execCommand("indentLess"),
                    "Ctrl-Space": "autocomplete",  // 用 Ctrl+Space 触发自动补全
                    "Ctrl-D": "deleteLine",
                    "Ctrl-Up": "goLineUp",
                    "Ctrl-Down": "goLineDown",
                    "Ctrl-Q": (cm) => cm.foldCodeSelection(), // 快捷键折叠选中代码
                    "Ctrl-E": (cm) => cm.unfoldCode() // 快捷键展开
                }
            };

                // 移除全屏模式初始设置（避免布局异常）
                // fullScreen: true 
            if(this.isHint){
                options.hintOptions = {hint:this.handleShowHint, completeSingle:false}
            }
            this.editor = window.CodeMirror.fromTextArea(this.$refs.codeEditor, options)
            this.value2 = this.value
            this.editor.setValue(this.value)
            this.editor.on("change",(instance, change)=>{
                // 1. 更新值（保持不变）
                const value = instance.getValue();
                this.value2 = value;
                this.$emit('input', value);
                // 2. 提示功能处理
                if ( this.isHint) {
                    // 防抖处理（300ms内不重复触发）
                    clearTimeout(this.hintTimer);
                    
                    this.hintTimer = setTimeout(() => {
                        // 获取当前光标位置和token
                        const cursor = instance.getCursor();
                        const token = instance.getTokenAt(cursor);
                        
                        // 触发提示的条件（满足任一即可）：
                        // a. 输入了字母/数字/中文
                        // b. 输入了 . 或 (
                        // c. 当前token包含提示字符
                        const shouldTrigger = 
                            /^[a-zA-Z0-9_\u4e00-\u9fa5.()]$/.test(change.text[0] || '') ||
                            /\.|\(/.test(token.string);
                        if (/*change.origin !== 'complete' &&*/ shouldTrigger) {
                            instance.showHint()
                        }
                    }, 300);
                }
            })
        },
        getMethodHints() {
            var hints = this.$hints[this.mode] || []
            return hints
                .filter(item => item.type === 'method')
                .map(item => ({
                    text: `${item.prop}(${item.params? (item.params.map(p => p.name).join(', ') || '') : ''})`,
                    displayText: `${item.label} ${item.prop}(${item.params? (item.params.map(p => p.name).join(', ') || '') : ''})`
                }));
        },
        handleShowHint(){
            const cursor = this.editor.getCursor()
            const token = this.editor.getTokenAt(cursor)
            const end = token.end || cursor
            const start = token.start || cursor
            let list = []
            if(this.handleHint){
                list = this.handleHint(cursor, token, this.value2)
            }
            return {list:list,from:window.CodeMirror.Pos(cursor.line,start),to:window.CodeMirror.Pos(cursor.line,end)}
        }
    }
}
</script>
<style >
 @import './index.less'
</style>